import { BaseSortConvertor } from './base.sort.convertor';

export class SortConvertor extends BaseSortConvertor {
}
